import React, { PropTypes, Component} from 'react';
import { connectToStores } from 'fluxible/addons';
import Category from '../components/Category';

class CategoryPage extends Component {
  static propTypes = {
    category: PropTypes.object.isRequired
  }

  static defaultProps = {
    category: ''
  }
  render() {
    var category = this.props.category;
    return (<Category entities={ category } /> );
  }
}

CategoryPage = connectToStores(CategoryPage, ['ServiceStore'], (stores, props) => {
  return {
    category: stores.ServiceStore.get()
  };
});

export default CategoryPage;


// WEBPACK FOOTER //
// ./src/pages/CategoryPage.js